module.exports = __webpack_public_path__ + "static/media/About.e5137ee5.jpg";